import { fmtCurrency, fmtPercent } from '@/helpers';
import { Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { memo } from 'react';

import { INF_RESULT_FIELD_LABELS } from '../constants';
import { EvaluationValuesSection } from '../types';

interface EvaluationResultProps {
  evaluationResult: EvaluationValuesSection;
}

export const EvaluationResult = memo(function EvaluationResult(
  props: EvaluationResultProps
) {
  const { evaluationResult } = props;

  return (
    <Grid
      id="inf-result"
      container
      spacing={3}
      marginBottom={3}
      marginTop="2px"
    >
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.homogenized_mean}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.estimated_value_mean)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.lower_limit}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.estimated_value_lower)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.upper_limit}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.estimated_value_upper)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.market_value}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.mean_total_value_estimate)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.lower_limit_total}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.min_total_value_estimate)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.upper_limit_total}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.max_total_value_estimate)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.lower_limit_confidence}
        </Typography>
        <Typography>
          {fmtPercent(evaluationResult.estimated_lower_pct)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.upper_limit_confidence}
        </Typography>
        <Typography>
          {fmtPercent(evaluationResult.estimated_upper_pct)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.rounded_market_value}
        </Typography>
        <Typography>
          {fmtCurrency(evaluationResult.rounded_market_value)}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_RESULT_FIELD_LABELS.report_date}
        </Typography>
        <Typography>
          {evaluationResult.report_date
            ? dayjs(evaluationResult.report_date).format('DD/MM/YYYY')
            : '-'}
        </Typography>
      </Grid>
    </Grid>
  );
});
